window.QV_PRODUCTS = window.QV_PRODUCTS || {};
let currentSlideIndex = 0;
let totalSlides = 0;
let startX = 0;
let endX = 0;

function money(cents) { return '$' + (cents / 100).toFixed(2); }

// --- 核心修改：多语言获取产品数据 ---
function getQVProduct(handle) {
  if (window.QV_PRODUCTS[handle]) return Promise.resolve(window.QV_PRODUCTS[handle]);

  // 自动获取 Shopify 当前语言根路径 (例如 "/" 或 "/zh-cn/")
  const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  // 拼接路径并防止出现双斜杠
  const url = `${root}products/${handle}.js`.replace(/\/+/g, '/');

  return fetch(url)
    .then(r => {
      if (!r.ok) throw new Error('Product not found');
      return r.json();
    })
    .then(p => {
      window.QV_PRODUCTS[handle] = p;
      return p;
    });
}

function updateVariantAvailability(product) {
  const container = document.getElementById('dkqv-variants-container');
  const optionWraps = container.querySelectorAll('.dkqv-variants');
  let currentSelected = [];
  optionWraps.forEach((wrap, index) => {
    const activeBtn = wrap.querySelector('.dkqv-variant.dkactive');
    currentSelected[index] = activeBtn ? activeBtn.textContent : null;
  });

  optionWraps.forEach((wrap, i) => {
    const buttons = wrap.querySelectorAll('.dkqv-variant');
    buttons.forEach(btn => {
      const val = btn.textContent;
      const isPossible = product.variants.some(v => {
        if (!v.available) return false; 
        return v.options.every((opt, j) => {
          if (i === j) return opt === val; 
          return opt === currentSelected[j]; 
        });
      });

      if (!isPossible) {
        btn.classList.add('is-sold-out');
      } else {
        btn.classList.remove('is-sold-out');
      }
    });
  });
}

function triggerGemPageCartUpdate() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    function getSectionsToRender() {
        const sections = [{ id: 'Cart-Icon-Bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
        if(cartDrawer && !cartDrawer.hasAttribute('data-status-silence')) {
            sections.push({ id: 'Cart-Drawer', section: cartDrawer.dataset.section, selector: '#Cart-Drawer-Details' });
        }
        return sections;
    }

    if (typeof webvista !== 'undefined') {
        const config = webvista.fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type']; 
        const formData = new FormData();
        formData.append('sections', getSectionsToRender().map((s)=>s.section).join());
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${window['routes']['cart_update_url']}`, config)
        .then(r => r.json())
        .then(response => {
            if (response.status) return;
            if (typeof SectionDynamicUpdate !== 'undefined') {
                SectionDynamicUpdate.updateSections(getSectionsToRender(), response['sections']);
            }
            webvista.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: response });
            cartDrawer.show(); 
        }).catch(err => console.error(err));
    }
}

function goToSlide(index) {
  const track = document.getElementById('dkqv-slider-track');
  const counter = document.getElementById('dkqv-slider-counter');
  if (!track || totalSlides === 0) return;
  if (index >= totalSlides) index = 0;
  if (index < 0) index = totalSlides - 1;
  currentSlideIndex = index;
  track.style.transform = `translateX(-${currentSlideIndex * 100}%)`;
  if (counter) counter.textContent = `${currentSlideIndex + 1} / ${totalSlides}`;
}

function changeSlide(direction) { goToSlide(currentSlideIndex + direction); }

function handleSwipe() {
  const threshold = 50;
  if (endX < startX - threshold) changeSlide(1);
  if (endX > startX + threshold) changeSlide(-1);
}

const sliderTrack = document.getElementById('dkqv-slider-track');
sliderTrack.addEventListener('touchstart', e => { startX = e.changedTouches[0].screenX; }, {passive: true});
sliderTrack.addEventListener('touchend', e => { endX = e.changedTouches[0].screenX; handleSwipe(); }, {passive: true});
sliderTrack.addEventListener('mousedown', e => { startX = e.screenX; });
sliderTrack.addEventListener('mouseup', e => { endX = e.screenX; handleSwipe(); });

function updateVariantInfo(product, selectedOptions) {
  const variant = product.variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
  const priceEl = document.getElementById('dkqv-price'), 
        originEl = document.getElementById('dkqv-orginprice'),
        variantIdInput = document.getElementById('dkqv-variant-id'), 
        addBtn = document.getElementById('dkqv-addtocart'),
        buyBtn = document.getElementById('decktok-checkout');

  if (variant) {
    variantIdInput.value = variant.id;
    priceEl.textContent = money(variant.price);
    originEl.style.display = (variant.compare_at_price > variant.price) ? 'inline' : 'none';
    if (variant.compare_at_price > variant.price) originEl.textContent = money(variant.compare_at_price);
    
    addBtn.disabled = !variant.available;
    buyBtn.disabled = !variant.available;
    addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

    if (variant.featured_image) {
      const featImgSrc = variant.featured_image.src.split('?')[0].replace(/^https?:/, '');
      const imgIndex = product.images.findIndex(imgSrc => imgSrc.split('?')[0].replace(/^https?:/, '').includes(featImgSrc));
      if (imgIndex !== -1) goToSlide(imgIndex);
    }
  }
}

function openQuickView(p, meta) {
  const modal = document.getElementById('dkqv-modal');
  const container = document.getElementById('dkqv-variants-container');
  const desContainer = document.getElementById('dkqv-description');
  const track = document.getElementById('dkqv-slider-track');
  const warrantyText = document.getElementById('dkqv-warranty-text');
  const warningContainer = document.getElementById('dkqv-warning-container');

  if (warrantyText) warrantyText.textContent = meta.warranty || "";
  document.getElementById('dkqv-title').textContent = p.title;
  document.getElementById('dkqv-qty-input').value = 1;
  document.getElementById('toggle-text').checked = false;

  if (meta.warningWord && meta.warningWord !== 'null' && meta.warningWord.trim() !== "") {
    document.getElementById('dkqv-warning-word').textContent = meta.warningWord;
    document.getElementById('dkqv-warning-icon').innerHTML = meta.warningIcon || "";
    warningContainer.style.display = 'flex';
  } else {
    warningContainer.style.display = 'none';
  }

  track.innerHTML = '';
  totalSlides = p.images.length;
  p.images.forEach(src => {
    const img = document.createElement('img');
    let resizedSrc = src.replace(/\.(jpg|jpeg|png|webp|gif)/gi, (match) => `_558x${match}`);
    img.src = resizedSrc;
    img.loading = "lazy";
    img.draggable = false;
    track.appendChild(img);
  });
  goToSlide(0);

  let desHtml = '';
  if(meta.model && meta.model !== 'null') desHtml += `<span style="color:white;" class="padding"><strong>${meta.model}</strong></span>`;
  if(meta.tip && meta.tip !== 'null') desHtml += `<span style="color:${meta.tipColor};">${meta.tip}</span>`;
  if(meta.simdes && meta.simdes !== 'null') desHtml += `<span style="color:white;">${meta.simdes}</span>`;
  desHtml += p.description; 
  desContainer.innerHTML = desHtml;

  container.innerHTML = '';
  let selectedOptions = [];
  
  if (p.variants.length > 1 || (p.variants[0] && !p.variants[0].title.includes('Default'))) {
    p.options.forEach((option, index) => {
      selectedOptions[index] = option.values[0];
      const label = document.createElement('span');
      label.textContent = option.name; 
      container.appendChild(label);
      const btnWrap = document.createElement('div');
      btnWrap.className = 'dkqv-variants';
      
      option.values.forEach(val => {
        const b = document.createElement('button');
        b.className = 'dkqv-variant'; 
        b.textContent = val;

        if (val === selectedOptions[index]) b.classList.add('dkactive');
        
        b.onclick = () => {
          btnWrap.querySelectorAll('.dkqv-variant').forEach(el => el.classList.remove('dkactive'));
          b.classList.add('dkactive');
          selectedOptions[index] = val;
          updateVariantAvailability(p); 
          updateVariantInfo(p, selectedOptions); 
        };
        btnWrap.appendChild(b);
      });
      container.appendChild(btnWrap);
    });
    container.style.display = 'block';
  } else {
    container.style.display = 'none';
    selectedOptions = p.variants[0].options;
  }

  updateVariantAvailability(p);
  updateVariantInfo(p, selectedOptions);

  const looxWrapper = document.getElementById('loox-reviews-wrapper');
  if (looxWrapper) {
    looxWrapper.innerHTML = `<div class="loox-rating" data-fetch data-id="${p.id}"></div>`;
    setTimeout(() => {
      if (typeof window.Loox !== 'undefined' && window.Loox.refresh) {
        window.Loox.refresh();
      } else {
        document.dispatchEvent(new CustomEvent('loox:refresh'));
      }
      if (window.LOOX && window.LOOX.init) window.LOOX.init();
    }, 50); 
  }

  modal.classList.remove('dkqvhidden');
}

document.addEventListener('click', e => {
  const btn = e.target.closest('.quickview-btn');
  if (btn) {
    const meta = {
      model: btn.dataset.model,
      tip: btn.dataset.tip,
      tipColor: btn.dataset.tipColor,
      simdes: btn.dataset.simdes,
      warranty: btn.dataset.warranty,
      warningIcon: btn.dataset.warningIcon,
      warningWord: btn.dataset.warningWord
    };
    getQVProduct(btn.dataset.handle).then(p => openQuickView(p, meta)).catch(err => console.error(err));
  }
  
  if (e.target.closest('.dkqv-close') || e.target.classList.contains('dkqv-mask')) {
    document.getElementById('dkqv-modal').classList.add('dkqvhidden');
  }

  const qtyBtn = e.target.closest('.qty-btn');
  if (qtyBtn) {
    const input = document.getElementById('dkqv-qty-input');
    let val = parseInt(input.value, 10) || 1;
    qtyBtn.dataset.action === 'plus' ? val++ : (val > 1 ? val-- : 1);
    input.value = val;
  }
});

document.getElementById('dkqv-addtocart').onclick = function() {
  const btn = this;
  const originalText = btn.textContent;
  const id = document.getElementById('dkqv-variant-id').value;
  const qty = document.getElementById('dkqv-qty-input').value;

  btn.disabled = false;
  btn.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: id, quantity: parseInt(qty) })
  })
  .then(response => response.json())
  .then(data => {
    btn.textContent = 'Added!';
    triggerGemPageCartUpdate();
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
      document.getElementById('dkqv-modal').classList.add('dkqvhidden');
    }, 300);
  })
  .catch(err => {
    console.error(err);
    btn.disabled = false;
    btn.textContent = 'Error';
  });
};

document.getElementById('decktok-checkout').onclick = function() {
  const id = document.getElementById('dkqv-variant-id').value;
  const qty = document.getElementById('dkqv-qty-input').value;
  window.location.href = `/cart/${id}:${qty}`;
};